import pelatihanDaringIMG from '../images/pelatihanDaring.png';
import pelatihanMandiriIMG from '../images/pelatihanMandiri.jpg';
import pelatihanTatapMukaIMG from '../images/pelatihanTatapMuka.jpeg';
import Button  from 'react-bootstrap/Button';
import {Link} from 'react-router-dom';

const PemilihanKelas = () => {
    return ( 
        <div className="pelatihan-container">
            <div className="pelatihan-card">
                <img className='pelatihan-img' src={pelatihanDaringIMG} alt="foto Online Learning" />
                <div className="pelatihan-description">
                    <h2>Pelatihan Daring</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sed ligula eget risus vestibulum dapibus at et ante. Suspendisse sed euismod dui. Sed mi enim, pharetra at diam sit amet, placerat facilisis leo. Vivamus sed dictum neque. Proin accumsan, felis vitae cursus eleifend, orci turpis aliquam felis, in tincidunt nibh odio et nisl. Donec vestibulum felis odio, in feugiat eros sodales eu. Ut porta mauris et risus fringilla lobortis.</p>
                    <Link to="/PelatihanDaring"><Button variant='secondary' className='pelatihan-button' size='lg'>Pilih</Button></Link>
                </div>
            </div>
            <hr />
            <div className="pelatihan-card">
                <img className='pelatihan-img' src={pelatihanTatapMukaIMG} alt="foto Online Learning" />
                <div className="pelatihan-description">
                    <h2>Pelatihan Tatap Muka</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sed ligula eget risus vestibulum dapibus at et ante. Suspendisse sed euismod dui. Sed mi enim, pharetra at diam sit amet, placerat facilisis leo. Vivamus sed dictum neque. Proin accumsan, felis vitae cursus eleifend, orci turpis aliquam felis, in tincidunt nibh odio et nisl. Donec vestibulum felis odio, in feugiat eros sodales eu. Ut porta mauris et risus fringilla lobortis.</p>
                    <Link to='/PelatihanTatapMuka'><Button variant='secondary' className='pelatihan-button' size='lg'>Pilih</Button></Link>
                </div>
            </div>
            <hr />
            <div className="pelatihan-card">
                <img className='pelatihan-img' src={pelatihanMandiriIMG} alt="foto Online Learning" />
                <div className="pelatihan-description">
                    <h2>Pelatihan Mandiri</h2>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus sed ligula eget risus vestibulum dapibus at et ante. Suspendisse sed euismod dui. Sed mi enim, pharetra at diam sit amet, placerat facilisis leo. Vivamus sed dictum neque. Proin accumsan, felis vitae cursus eleifend, orci turpis aliquam felis, in tincidunt nibh odio et nisl. Donec vestibulum felis odio, in feugiat eros sodales eu. Ut porta mauris et risus fringilla lobortis.</p>
                    <Button variant='secondary' className='pelatihan-button' size='lg'>Pilih</Button>
                </div>
            </div>
        </div>
     );
}
 
export default PemilihanKelas;